module.exports = __webpack_public_path__ + "static/building_4x-8002e5697e6fbd6f9442bdc96c839699.jpg";